import SessionEventProto from "../session-event-proto";

const {SESSION_PROJECT_USERS_CHANGED} = require("../../gd/bus/bus-event-type")


export default class EventProjectUsersReset extends SessionEventProto {


    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {

        if (this.isDifferentCompany()) return false;

        gd.session.projectUsers.resetAndKeepOldModels(this.data)

        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
    }
}


// var Event = function(uid,data) {
//     this.data = data;
//     this.uid = uid;
// };
//
// Event.prototype.validate = function(){
//     return true;
// };
//
// Event.prototype.process = function(){
//     gd.session.projectUsers.resetAndKeepOldModels(this.data)
//     gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
// };
//
// module.exports = Event;
